import { useEffect } from 'react'

export function useVhFix (): void {
  useEffect(() => {
    const setVh = (): void => {
      requestAnimationFrame(() => {
        const vh = window.innerHeight / 100
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    }
    setVh()

    window.addEventListener('resize', setVh)
    return () => { window.removeEventListener('resize', setVh) }
  }, [])
}
